<template>
  <SectionRowContainer class="aboutme-snippet">
    <b-col md>
      <h3><b>ABOUT MYSELF</b></h3>
      <p>
        Someone who always has a curious mind and always in search of
        answers. Long time software developer that likes to experiment
        and develop with many different technologies out there. Like
        being in nature, and with a passion to travel and explore what
        the world has to offer.
      </p>
      <InfoCards :infos="aboutmeInfoCardData" />
    </b-col>

    <b-col md="1"></b-col>

    <b-col md>
      <IconGrid title="TECHINCAL EXPERIENCE" :images="technicalExperienceLogos"/>
    </b-col>
  </SectionRowContainer>
</template>

<script>
import IconGrid from './layout/IconGrid.vue';
import InfoCards from './InfoCards.vue';
import SectionRowContainer from './layout/SectionRowContainer.vue';

import aboutmeInfoCardData from '../assets/data/aboutme-info-card-data.json';
import technicalExperienceLogos from '../assets/data/technical-experience-logos.json';

export default {
  name: 'AboutMeSnippet',
  components: {
    IconGrid,
    InfoCards,
    SectionRowContainer
  },
  data() {
    return {
      aboutmeInfoCardData,
      technicalExperienceLogos
    }
  }
};
</script>

<style lang="scss" scoped>
.aboutme-snippet {
  margin-top: 20px;
}
</style>
